import { useAuth as useOidcAuth } from 'react-oidc-context';

const INTENDED_URL_KEY = 'auth_intended_url';

export const useAuth = () => {
  const auth = useOidcAuth();

  return {
    user: auth.user,
    isAuthenticated: auth.isAuthenticated,
    isLoading: auth.isLoading,

    accessToken: auth.user?.access_token,

    login: () => {
      const intendedUrl = globalThis.location.pathname + globalThis.location.search;
      sessionStorage.setItem(INTENDED_URL_KEY, intendedUrl);
      return auth.signinRedirect();
    },
    logout: () => auth.signoutRedirect(),

    renewToken: () => auth.signinSilent(),

    error: auth.error,
  };
};
